import React, { FC } from 'react';
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { HeaderModel } from '../../../models/CommonModel';
import { usePermissionChecker } from '../../../hooks/PermissionChecker';
import SortableColumn from '../../../components/Table/SortableColumn';
import { formatPrice } from '../../../selectors';
import { SaleRowModel } from '../../../models/account-books/SalesAccount';
import { TaxRowModel } from '../../../models/account-books/TaxAccount';
import moment from 'moment';

type Props = {
    data: Array<TaxRowModel>,
    header: HeaderModel[]
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
};

const TaxAccountTable: FC<Props> = ({ data, header, hideCols, openColConfig, handleSort }) => {
    const renderMethod = (method: string) => {
        switch (method) {
            case 'cash':
                return 'Tiền mặt';
            case 'bank':
                return 'Chuyển khoản';
        }
    }
    return (
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th>
                            <i 
                                className="fa fa-cogs"
                                style={{cursor: 'pointer'}}
                                onClick={openColConfig}
                            ></i>
                        </th>
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: TaxRowModel, index: number) => {
                        let postDate = item.li_ability?.created_at ? moment(item.li_ability?.created_at).format('DD-MM-YYYY') : item.posting_date;
                        return (
                            <tr key={`agent_${index}`} className="cursor-pointer">
                                <td></td>
                                {!hideCols.includes('voucher_no') && (
                                <td>{item?.voucher_no ?? ''}</td>
                                )}
                                {!hideCols.includes('posting_date') && (
                                <td>
                                    {postDate}
                                </td>
                                )}
                                {!hideCols.includes('description') && (
                                <td >{item.description}</td>
                                )}
                                {!hideCols.includes('amount') && (
                                <td>{formatPrice(item.amount)}</td>
                                )}
                                
                                {!hideCols.includes('method') && (
                                <td >{renderMethod(item.method)}</td>
                                )}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default TaxAccountTable;